module.exports = "/static/assets/8bcd83eb9f0ebad59295f94c2dd7b3b6.png";